import { render, staticRenderFns } from "./SecretVerify.vue?vue&type=template&id=643b7ebe&scoped=true&"
import script from "./SecretVerify.vue?vue&type=script&lang=js&"
export * from "./SecretVerify.vue?vue&type=script&lang=js&"
import style0 from "./SecretVerify.vue?vue&type=style&index=0&id=643b7ebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b7ebe",
  null
  
)

export default component.exports